import { userConstants } from '../constants';

let user = JSON.parse(localStorage.getItem('user') as string);
const initialState = user ? { loggedIn: true, user } : {};

export const authentication = (
  state: {
    loggedIn?: boolean;
    user?: any; // TODO: come back to change this
    isLoadingMeInfo?: boolean;
    error?: string;
  } = initialState,
  action: { type: string; payload: any },
) => {
  switch (action.type) {
    case userConstants.LOGIN_REQUEST:
      return {
        loggingIn: true,
        user: action.payload.user,
      };
    case userConstants.LOGIN_SUCCESS:
      return {
        loggedIn: true,
        user: action.payload.user,
      };
    case userConstants.LOGIN_ERROR:
    case userConstants.LOGOUT:
      return {};
    case userConstants.ME_INFO_REQUEST:
      return {
        ...state,
        isLoadingMeInfo: true,
      };
    case userConstants.ME_INFO_SUCCESS:
      return {
        ...state,
        isLoadingMeInfo: false,
        user: {
          ...state.user,
          ...(action.payload.data ?? {}),
        },
      };
    case userConstants.ME_INFO_ERROR:
      return {
        ...state,
        isLoadingMeInfo: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};
